import { render, staticRenderFns } from "./transRecord.vue?vue&type=template&id=82bcd2a0&scoped=true&"
import script from "./transRecord.vue?vue&type=script&lang=js&"
export * from "./transRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bcd2a0",
  null
  
)

export default component.exports